import { useState, useEffect } from "react";
import { CartServiceAccessor } from "../../utilities/cartServiceAccessor";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { AddToCartResult } from "@wbmason/add-to-cart";
import ConfigProps from "../../constants/configProps";
import ConfigPropService from "../../utilities/configPropService";
import EnvironmentService from "../../utilities/environmentService";
import ScrollBarService from "../../utilities/scrollBarService";
import { WBMUrlService } from "@wbmason/url-service";
import { BaseHostUrlService } from "../../utilities/baseHostUrlService";
import { IAddToCartProviderProps } from "./AddToCartProvider";
import "./addToCart.scss";

// set it to true to test add to cart
const enableTestButton = false;

const AddToCartProviderClient = (props: IAddToCartProviderProps) => {
  const [configProps, setConfigProps] = useState<Record<string, string>>();

  const ECOM_BASE_URL = WBMUrlService.getEcomUrl(
    BaseHostUrlService.get(),
    EnvironmentService.get().ecom,
  );

  const PDP_BASE_URL = WBMUrlService.getPDPUrl(
    BaseHostUrlService.get(),
    EnvironmentService.get().ecomPDP,
  );

  useEffect(() => {
    const configPropSub = ConfigPropService.get([
      ConfigProps.DisplayCloseButtonOnSupercedesPopup,
      ConfigProps.QuantityLimitMessage,
      ConfigProps.EnableSkuGroupAddToCart,
      ConfigProps.EnableSinglePageCheckout,
      ConfigProps.EnableAllSalesFinal,
      ConfigProps.NoImageAvailableImage,
      ConfigProps.AllSalesFinalText,
      ConfigProps.DisplayListPrice,
      ConfigProps.CouponCustomerLimitMessage,
      ConfigProps.CouponQtyLimitMessage,
      ConfigProps.RestrictedLink,
      ConfigProps.RestrictedMessage,
      ConfigProps.DisplayRelevanceScore,
      ConfigProps.DisplayIndividualUnitPrice,
      ConfigProps.DisplayRestrictedItemPrice,
      ConfigProps.ManageGroupLists,
      ConfigProps.ManageRestrictions,
      ConfigProps.UsePunchout,
      ConfigProps.EnableGroupByTracker,
      ConfigProps.GroupByArea,
      ConfigProps.GroupByCustomerID,
      ConfigProps.EnableGroupBySearch,
      ConfigProps.GroupByCollection,
      ConfigProps.EnableResponsiveSearchResults,
      ConfigProps.EnableSEOContentInProductURLs,
      ConfigProps.ActivateAdobeTargetDIVTagSafeZones,
      ConfigProps.DisplayAddToCartPromoItems,
      ConfigProps.QuantityMaxDigits,
      ConfigProps.ActivateAdobeAddToCartPromoItems,
      ConfigProps.EnableResponsiveShoppingCart,
      ConfigProps.DisplayAddtoCartPopup,
      ConfigProps.EnableOptionalChildLines,
    ]).subscribe((configProps: Record<string, string>) => {
      setConfigProps(configProps);
    });

    return () => {
      configPropSub.unsubscribe();
    };
  }, []);

  const addToCartTest = (itemsToAdd: Array<any>) => {
    const params = itemsToAdd.map((q) => {
      return {
        itemIdentifier: {
          id: q.itemId,
          unitId: q.unitId,
          couponOfferCode: "",
        },
        qty: 1,
        notes: "test notes",
        isPostSupercedeValidation: false,
        isSupercede: false,
        itemPosition: 4,
        itemSellPrice: 6.49,
      };
    });
    CartServiceAccessor()
      .addCartItems(params, itemsToAdd.length === 1)
      .subscribe();
  };

  const AddItemsToCartAsync = () => {
    // test multiple add to cart calls firing off asynchronously to repro the multiple active carts issue
    const itemsToAdd = [
      {
        itemId: "PAP3331131",
        unitId: "DZ",
      },
      {
        itemId: "BLZH2O3G",
        unitId: "EA",
      },
      {
        itemId: "ZEB22220",
        unitId: "DZ",
      },
      {
        itemId: "BVCCR0620030",
        unitId: "EA",
      },
      {
        itemId: "AAG5035",
        unitId: "EA",
      },
    ];
    itemsToAdd.forEach((item) => {
      addToCartTest([item]);
    });
  };

  return (
    <>
      {configProps && (
        <AddToCartResult
          configProps={configProps}
          checkoutProps={{
            hasItemAgreements: props.hasItemAgreements,
            checkoutAppUri: props.checkoutAppUri,
            isLoggedIn: props.isLoggedIn,
            loginUrl: props.preLoadedLoginUrl,
            ECOM_BASE_URL: ECOM_BASE_URL,
            PDP_BASE_URL: PDP_BASE_URL,
            baseHostUrl: BaseHostUrlService.get(),
            reactShoppingCart: EnvironmentService.get().ecomShoppingCart,
          }}
          appendRemoveContainerWidth={(isOpen: boolean) => {
            ScrollBarService.applyModalOpen(isOpen, "add to cart", true);
          }}
        />
      )}
      {enableTestButton && (
        <>
          <div className="mt-5 mb-3">
            <button onClick={AddItemsToCartAsync}> Add To Cart</button>
            <span className="ml-3">(Multiple active carts)</span>
          </div>
          <div className="mt-3 mb-3">
            <button
              onClick={() => {
                addToCartTest([{ itemId: "PAP3331131", unitId: "DZ" }]);
              }}
            >
              Add To Cart
            </button>
            <span className="ml-3">(Standard add to cart)</span>
          </div>
          <div className="mb-3">
            <button
              onClick={() => {
                addToCartTest([{ itemId: "WBM21200", unitId: "RM" }]);
              }}
            >
              Add To Cart
            </button>
            <span className="ml-3">(Prevent Add To Cart Popup)</span>
          </div>
          <div className="mb-3">
            <button
              onClick={() => {
                addToCartTest([{ itemId: "GPC52053", unitId: "EA" }]);
              }}
            >
              Add To Cart
            </button>
            <span className="ml-3">(Lease Agreement)</span>
          </div>
          <div className="mb-3">
            <button
              onClick={() => {
                addToCartTest([{ itemId: "OFFICESUPPLYKIT", unitId: "KT" }]);
              }}
            >
              Add To Cart
            </button>
            <span className="ml-3">(Kit Items)</span>
          </div>
          <div className="mb-3">
            <button
              onClick={() => {
                addToCartTest([{ itemId: "BLZH2O3G", unitId: "EA" }]);
              }}
            >
              Add To Cart
            </button>
            <span className="ml-3">(Additional Charges)</span>
          </div>
          <div className="mb-3">
            <button
              onClick={() => {
                addToCartTest([{ itemId: "BVCCR0620030", unitId: "EA" }]);
              }}
            >
              Add To Cart
            </button>
            <span className="ml-3">(Optional Child Lines)</span>
          </div>
          <hr />
          <div className="mb-3">
            <button
              onClick={() => {
                addToCartTest([{ itemId: "BLZH2O3G", unitId: "EA" }]);
              }}
            >
              Add To Cart
            </button>
            <span className="ml-3">(Additional Charges from Slideout)</span>
          </div>
          <div className="mb-3">
            <button
              onClick={() => {
                addToCartTest([{ itemId: "BVCCR0620030", unitId: "EA" }]);
              }}
            >
              Add To Cart
            </button>
            <span className="ml-3">(Optional Child Lines from Slideout)</span>
          </div>
          <div className="mb-3">
            <button
              onClick={() => {
                addToCartTest([{ itemId: "TBO108X36X120", unitId: "KT" }]);
              }}
            >
              Add To Cart
            </button>
            <span className="ml-3">(Kit Items from Slideout)</span>
          </div>
          <hr />
          <div className="mb-3">
            <button
              onClick={() => {
                addToCartTest([{ itemId: "UNV55400", unitId: "DZ" }]);
              }}
            >
              Add To Cart
            </button>
            <span className="ml-3">(Qty Limits)</span>
          </div>
          <div className="mb-3">
            <button
              onClick={() => {
                addToCartTest([{ itemId: "ZEB22220", unitId: "DZ" }]);
              }}
            >
              Add To Cart
            </button>
            <span className="ml-3">(Hard Swaps)</span>
          </div>
          <div className="mb-3">
            <button
              onClick={() => {
                addToCartTest([{ itemId: "AAG5035", unitId: "EA" }]);
              }}
            >
              Add To Cart
            </button>
            <span className="ml-3">(Soft Swaps)</span>
          </div>
          <div className="mb-3">
            <button
              onClick={() => {
                addToCartTest([{ itemId: "ACM10375", unitId: "EA" }]);
              }}
            >
              Add To Cart
            </button>
            <span className="ml-3">(Soft Swaps with Grouping)</span>
          </div>
          <div className="mb-3">
            <button
              onClick={() => {
                addToCartTest([{ itemId: "BLZH2O3G", unitId: "PK" }]);
              }}
            >
              Add To Cart
            </button>
            <span className="ml-3">(Invalid Cart Items)</span>
          </div>
          <div className="mb-3">
            <button
              onClick={() => {
                addToCartTest([{ itemId: "SMD14537", unitId: "BX" }]);
              }}
            >
              Add To Cart
            </button>
            <span className="ml-3">(Restricted Kit Item Add To Cart)</span>
          </div>
          <hr />
          <div className="mb-3">
            <button
              onClick={() => {
                addToCartTest([{ itemId: "PAP3381131", unitId: "DZ" }]);
              }}
            >
              Add To Cart
            </button>
            <span className="ml-3">(Prevent AddToCart from Slideout)</span>
          </div>
          <div className="mb-3">
            <button
              onClick={() => {
                addToCartTest([{ itemId: "PAP3331131", unitId: "DZ" }]);
              }}
            >
              Add To Cart
            </button>
            <span className="ml-3">(Hard Swap from Slideout)</span>
          </div>
          <div className="mb-3">
            <button
              onClick={() => {
                addToCartTest([{ itemId: "BICGSF11BE", unitId: "DZ" }]);
              }}
            >
              Add To Cart
            </button>
            <span className="ml-3">(Qty Limits from Slideout)</span>
          </div>
          <div className="mb-3">
            <button
              onClick={() => {
                addToCartTest([{ itemId: "AVE17012", unitId: "EA" }]);
              }}
            >
              Add To Cart
            </button>
            <span className="ml-3">(Soft Swaps from Slideout)</span>
          </div>
          <hr />
          <div className="mb-3">
            <button
              onClick={() => {
                addToCartTest([
                  { itemId: "PGC07535", unitId: "CT" },
                  { itemId: "LRNLER2788", unitId: "ST" },
                  { itemId: "PHKITQT10", unitId: "EA" },
                ]);
              }}
            >
              Add To Cart
            </button>
            <span className="ml-3">(Bulk Add to Cart for standard Items)</span>
          </div>
          <div className="mb-3">
            <button
              onClick={() => {
                addToCartTest([
                  { itemId: "AVE17012", unitId: "EA" },
                  { itemId: "AAG5035", unitId: "EA" },
                  { itemId: "ACM10375", unitId: "EA" },
                ]);
              }}
            >
              Add To Cart
            </button>
            <span className="ml-3">
              (Bulk Add to Cart (three supersedes items))
            </span>
          </div>
          <div className="mb-3">
            <button
              onClick={() => {
                addToCartTest([
                  { itemId: "AVE17012", unitId: "EA" },
                  { itemId: "UNV10210", unitId: "DZ" },
                  { itemId: "ACM10375", unitId: "EA" },
                ]);
              }}
            >
              Add To Cart
            </button>
            <span className="ml-3">
              (Bulk Add to Cart (combination of supersedes & qty limits))
            </span>
          </div>
          <div className="mb-3">
            <button
              onClick={() => {
                addToCartTest([
                  { itemId: "AAGSK2400", unitId: "EA" },
                  { itemId: "UNV10210", unitId: "DZ" },
                  { itemId: "UNV55400", unitId: "DZ" },
                ]);
              }}
            >
              Add To Cart
            </button>
            <span className="ml-3">(Bulk Add to Cart (qty limits items))</span>
          </div>
        </>
      )}
    </>
  );
};

export default AddToCartProviderClient;
